import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches system invoice approver roles (same shape as admin approver roles list).
 */
export const getSystemApproverRoles = async () => {
  try {
    const response = await apiClient.get('/systemInvoiceRoleManagement');
    if (response.data && response.data.response) {
      return response.data.response;
    }
    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
